import Navbar from "../../components/feature/Navbar";
import Footer from "../../pages/home/components/Footer";

const termsContent = [
  {
    title: "1. Introduction",
    paragraphs: [
      "Welcome to this website (the \"Site\"), operated by Nova Vertex LTD (\"Company\", \"we\", \"our\", or \"us\").",
      "Registered Office:\nInternational House\n66 Lavender Hill\nLondon\nSW11 5RQ\nUnited Kingdom\nsupport@novavertextech.com\n+44 7520 663474",
      "These Terms of Use (\"Terms\") govern your access to and use of the Site and any content, information, or services made available through it (collectively, the \"Service\").",
      "By accessing or using the Site, you confirm that you have read, understood, and agree to be bound by these Terms, as well as our Privacy Policy and Cookie Policy. If you do not agree, you must not use the Site."
    ]
  },
  {
    title: "2. Definitions",
    paragraphs: [
      'For the purposes of these Terms:\n"Site" means this website and all related pages, features, and content\n"Company" refers to Nova Vertex LTD\n"Service" means any content, materials, or functionality provided through the Site\n"User", "you" means any person accessing or using the Site\n"Content" means all text, graphics, logos, media, and materials available on the Site'
    ]
  },
  {
    title: "3. Eligibility",
    paragraphs: [
      "By using the Site, you confirm that:\nYou are at least 18 years old or the age of majority in your jurisdiction\nYou have the legal capacity to enter into binding agreements\nYou will comply with all applicable laws and regulations"
    ]
  },
  {
    title: "4. Use of the Site",
    paragraphs: [
      "You agree to use the Site only for lawful purposes and in accordance with these Terms.",
      "You must not:\nUse the Site in violation of any applicable laws\nAttempt to gain unauthorized access to systems or data\nInterfere with the operation, security, or integrity of the Site\nUse automated tools (bots, scrapers) without authorization\nEngage in any activity that may harm the Company or other users"
    ]
  },
  {
    title: "5. Intellectual Property Rights",
    paragraphs: [
      "All Content and materials on the Site are owned by or licensed to Nova Vertex LTD and are protected by intellectual property laws.",
      "You are granted a limited, non-exclusive, non-transferable license to access and use the Site for personal or internal business purposes.",
      "You may not:\nCopy, reproduce, or distribute Content without permission\nModify or create derivative works\nUse Company branding, trademarks, or logos without written consent"
    ]
  },
  {
    title: "6. User Content and Communications",
    paragraphs: [
      "If you submit any content, inquiries, or communications through the Site:\nYou retain ownership of your content\nYou grant the Company a non-exclusive, royalty-free right to use such content for operational purposes (e.g., responding to inquiries)\nYou confirm that your content does not violate any laws or third-party rights"
    ]
  },
  {
    title: "7. Third-Party Services and Links",
    paragraphs: [
      "The Site may contain links to third-party websites or services.",
      "The Company:\nDoes not control third-party services\nIs not responsible for their content, availability, or policies\nDoes not guarantee their accuracy or reliability\nUse of third-party services is at your own risk."
    ]
  },
  {
    title: "8. Disclaimer of Warranties",
    paragraphs: [
      'The Site and all Content are provided on an "as is" and "as available" basis.',
      "To the fullest extent permitted by law, the Company:\nMakes no warranties regarding accuracy, completeness, or reliability\nDoes not guarantee uninterrupted or error-free operation\nDoes not guarantee the absence of viruses or harmful components"
    ]
  },
  {
    title: "9. Limitation of Liability",
    paragraphs: [
      "To the maximum extent permitted by law, Nova Vertex LTD shall not be liable for:\nAny indirect, incidental, or consequential damages\nLoss of profits, data, or business opportunities\nAny damages arising from use or inability to use the Site",
      "Nothing in these Terms excludes liability that cannot be excluded under applicable law."
    ]
  },
  {
    title: "10. User Responsibility",
    paragraphs: [
      "You are responsible for:\nEnsuring your use of the Site complies with applicable laws\nMaintaining the security of your devices and data\nAny actions taken while using the Site"
    ]
  },
  {
    title: "11. Privacy and Data Protection",
    paragraphs: [
      "Your use of the Site is subject to our Privacy Policy.",
      "We process personal data in accordance with applicable data protection laws, including UK GDPR where applicable."
    ]
  },
  {
    title: "12. Modifications to the Site and Terms",
    paragraphs: [
      "The Company reserves the right to:\nModify or discontinue any part of the Site at any time\nUpdate these Terms when necessary",
      "Updated Terms will be posted on this page. Continued use of the Site constitutes acceptance of the updated Terms."
    ]
  },
  {
    title: "13. Suspension and Termination",
    paragraphs: [
      "We reserve the right to suspend or restrict access to the Site if:\nYou violate these Terms\nYour use poses a risk to the Site or other users\nRequired by law or regulatory authorities"
    ]
  },
  {
    title: "14. Governing Law",
    paragraphs: [
      "These Terms shall be governed by and interpreted in accordance with the laws of England and Wales."
    ]
  },
  {
    title: "15. Severability",
    paragraphs: [
      "If any provision of these Terms is found to be invalid or unenforceable, the remaining provisions shall remain in full force and effect."
    ]
  },
  {
    title: "16. Entire Agreement",
    paragraphs: [
      "These Terms constitute the entire agreement between you and the Company regarding use of the Site and supersede any prior agreements."
    ]
  },
  {
    title: "17. Contact Information",
    paragraphs: [
      "Nova Vertex LTD\nInternational House\n66 Lavender Hill\nLondon\nSW11 5RQ\nUnited Kingdom\nsupport@novavertextech.com\n+44 7520 663474"
    ]
  }
];

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-nv-light flex flex-col">
      <div className="bg-nv-black">
        <Navbar />
      </div>

      <main className="flex-1">
        <section className="py-16 md:py-24 px-6 md:px-10 lg:px-16">
          <div className="max-w-3xl mx-auto">
            <a
              href="/"
              className="inline-flex items-center gap-2 text-nv-gray text-sm hover:text-nv-black transition-colors mb-8 group"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-line text-sm group-hover:-translate-x-0.5 transition-transform"></i>
              </span>
              Back to Main Page
            </a>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-nv-black tracking-tight mb-6">
              Terms of Use
            </h1>
            <p className="text-nv-gray text-sm md:text-base mb-12 md:mb-16">
              Last updated: 4 May 2026
            </p>

            <div className="flex flex-col gap-10 md:gap-14">
              {termsContent.map((section) => (
                <div key={section.title}>
                  <h2 className="text-xl md:text-2xl font-medium text-nv-black mb-4 md:mb-5">
                    {section.title}
                  </h2>
                  <div className="flex flex-col gap-4">
                    {section.paragraphs.map((paragraph, idx) => (
                      <div
                        key={idx}
                        className="text-nv-gray text-sm md:text-base leading-relaxed whitespace-pre-line"
                      >
                        {paragraph}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}